<script>
import InvoicesTable from "@/views/Tables/InvoicesTable.vue"
import StatsCard from "@/components/StatsCard.vue"

export default {
  name: "EmployeeInvoices",
  components: {InvoicesTable, StatsCard},
  data() {
    return {
      summaryLoading: true,
      summaryFailed: false,
      summary: null,
    }
  },
  computed: {
    summaryTiles() {
      const summary = this.summary ?? {}
      return [
        {key: "paid", title: this.$t("PAID"), type: "gradient-green", icon: "fa fa-check", totals: summary.paid},
        {key: "pending", title: this.$t("PENDING"), type: "warning", icon: "fa fa-hourglass-half", totals: summary.pending},
        {key: "overdue", title: this.$t("Overdue"), type: "danger", icon: "fa fa-exclamation-triangle", totals: summary.overdue},
      ]
    }
  },
  async mounted() {
    await this.getSummary()
  },
  methods: {
    async getSummary() {
      this.summaryLoading = true
      this.summaryFailed = false
      try {
        this.summary = await this.$store.dispatch("fetchEmployeeInvoiceSummary", this.$route.params.id)
      } catch (error) {
        console.log("fetchEmployeeInvoiceSummary error", error)
        this.summaryFailed = true
      } finally {
        this.summaryLoading = false
      }
    },
    formatCents(cents) {
      return new Intl.NumberFormat(this.$i18n.locale === "gr" ? "el-GR" : this.$i18n.locale, {style: "currency", currency: "EUR"}).format((cents ?? 0) / 100)
    },
  }
}
</script>

<template>
  <div>
    <div class="row mb-4">
      <div v-for="tile in summaryTiles" :key="tile.key" class="col-md-4 mb-3 mb-md-0">
        <stats-card
            :title="tile.title"
            :type="tile.type"
            :icon="tile.icon"
            :loading="summaryLoading"
            :sub-title="summaryFailed ? '—' : formatCents(tile.totals?.total)"
        >
          <template #footer>
            <span v-if="summaryFailed" class="text-danger">{{ $t("Could not load the invoice summary.") }}</span>
            <span v-else-if="!summaryLoading" class="text-nowrap">{{ $t("{count} invoices", {count: tile.totals?.count ?? 0}) }}</span>
          </template>
        </stats-card>
      </div>
    </div>
    <invoices-table :employee-id="$route.params.id"></invoices-table>
  </div>
</template>

<style scoped>

</style>
